import { render, staticRenderFns } from "./SentenceParsing.vue?vue&type=template&id=36da9cd1&lang=pug&"
import script from "./SentenceParsing.vue?vue&type=script&lang=js&"
export * from "./SentenceParsing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports